// extracted by mini-css-extract-plugin
export var columnList = "_ed-0";